import LoadingButton from "@mui/lab/LoadingButton";
import {FormControlLabel, Grid, Radio, RadioGroup, Typography} from "@mui/material";
import Colors from "../../../utils/Colors";
import {FeedbackPageService} from "./FeedbackPageService";
import {Containter, FieldText, QuestionnaireTitle, Title} from "./styled";

export function FeedbackPage() {
    const {
        createFeedback,
        handleMessageChange,
        message,
        loading,
        questionnaire,
        getAnswer,
        selectAnswer,
        clearAnswer,
        canSend
    } = FeedbackPageService();
    const block = loading || !canSend;
    return (
        <Containter>
            <Title>We value your feedback.</Title>
            <Grid mt={3}>
                <Title>If you have any suggestions, recommendations, questions, complaints or compliments, please let us
                    know. </Title>
                <Grid mt={2}>
                    <FieldText
                        inputProps={{style: {color: Colors.WHITE}}}
                        autoFocus
                        rows={4}
                        multiline
                        value={message}
                        onChange={handleMessageChange}
                        placeholder="Feedback"
                        id="feedback"
                        variant="outlined"
                        fullWidth
                        InputProps={{readOnly: loading}}
                    />
                </Grid>
            </Grid>

            <Grid mt={3}>
                <QuestionnaireTitle>{questionnaire.title}</QuestionnaireTitle>
                {questionnaire.questions.map((question) => (
                    <Grid key={question.id} mt={2}>
                        <Title>{question.text}</Title>
                        <RadioGroup
                            name={question.id}
                            value={getAnswer(question.id)}
                            onChange={(e) => !loading && selectAnswer(question.id, e.target.value)}
                            sx={{mt: 1, ml: 1, gap: 1}}
                        >
                            {question.answers.map((answer) => (
                                <FormControlLabel
                                    key={answer.id}
                                    value={answer.id}
                                    disabled={loading}
                                    control={
                                        <Radio
                                            sx={{padding: 0, mr: 1, color: Colors.WHITE, "&.Mui-checked": {color: Colors.WHITE}}}
                                            disableRipple
                                            // Clicking the selected answer again clears the question (all questions are optional).
                                            onClick={() => getAnswer(question.id) === answer.id && clearAnswer(question.id)}
                                        />
                                    }
                                    label={<Typography sx={{fontSize: 12}} variant="subtitle2">{answer.text}</Typography>}
                                    sx={{m: 0}}
                                />
                            ))}
                        </RadioGroup>
                    </Grid>
                ))}
            </Grid>

            <Grid mt={2} display="flex" justifyContent="end">
                <LoadingButton
                    loading={loading}
                    loadingPosition="start"
                    disabled={block}
                    sx={{
                        ...(block && {backgroundColor: "#004fa7 !important", color: "#b4c1cb !important"}),
                        width: "110px"
                    }}
                    variant="contained"
                    onClick={createFeedback}
                >
                    Send
                </LoadingButton>
            </Grid>
        </Containter>
    );
}
